import { get } from '@rails/request.js';

export const TurboMixin = (controller) => {
  Object.assign(controller, {
    turboGet(baseUrl, queryParams = {}) {
      const url = this.buildUrl(baseUrl, queryParams);

      get(url, {
        contentType: 'text/vnd.turbo-stream.html',
        responseKind: 'turbo-stream',
      });
    },

    buildUrl(baseUrl, queryParams) {
      const params = Object.entries(queryParams)
        .map(([param, value]) => `${param}=${value}`)
        .join('&');

      if(baseUrl.includes("?")) {
        return baseUrl + `&${params}`;
      }

      return baseUrl + `?${params}`;
    },
  });
};
